import { useMemo, useState } from "react";
import type { RainHistoryImportFormState } from "../rainHistory.types";

const initialState: RainHistoryImportFormState = {
  retreat: { value: null },
};

export function useRainHistoryImportForm() {
  const [formState, setFormState] = useState<RainHistoryImportFormState>({
    ...initialState,
  });

  const handleSelectRetreat = (retreatId: number | null) => {
    setFormState((prevState) => ({
      ...prevState,
      retreat: { value: retreatId },
    }));
  };

  const handleResetForm = () => {
    setFormState({ ...initialState });
  };

  const canSubmitForm = useMemo(() => {
    return formState.retreat.value != null;
  }, [formState.retreat]);

  return {
    formState,
    canSubmitForm,
    handleSelectRetreat,
    handleResetForm,
  };
}
